import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface ICardFeesFormMeta {
    
    // ====== Card Fees =======
    cardCommission: FormInputMeta;
    customizationFees: FormInputMeta;
    renewableFees: FormInputMeta;
    membershipFees: FormInputMeta;
    pinReCalculationFees: FormInputMeta;
};

const cardFeesFormMeta = {} as ICardFeesFormMeta;

cardFeesFormMeta.cardCommission = {
    name: "cardCommission",
    type: "select",
    label: "Commission Carte",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

cardFeesFormMeta.customizationFees = {
    name: "customizationFees",
    type: "select",
    label: "Frais Personnalisation",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

cardFeesFormMeta.renewableFees = {
    name: "renewableFees",
    type: "select",
    label: "Frais Renouvellement",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

cardFeesFormMeta.membershipFees = {
    name: "membershipFees",
    type: "select",
    label: "Frais d'Adhésion",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

cardFeesFormMeta.pinReCalculationFees = {
    name: "pinReCalculationFees",
    type: "select",
    label: "Frais Re-Calcul Pin",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};


export default cardFeesFormMeta;